import UserAvatar from '../../../components/common/UserAvatar';
import { MediumBase } from '../../../components/core/typography';
import { getIcon } from '../../../components/core/vticon';
import React from 'react';


interface LoginProps {
    handleClick:()=>void,
    content:string

    }

    
const VtEditInput :React.FC<LoginProps> = ({handleClick,content}) => {
	return (
		<div className='w-[100%] h-[44px] border border-[#d9d9d9] rounded-md px-[14px] py-[12px] flex justify-between items-center
        shadow'>
			<div className='flex gap-2'>
				<UserAvatar name={content} round={true} size={'24'} />
				<MediumBase text={content} color='#344054' />
			</div>
			<div className='cursor-pointer' onClick={()=>handleClick()}>{getIcon('Exit', 16, 16, '#667085')}</div>
		</div>
	);
};

export default VtEditInput;
